import React, { Component } from "react";
import {
    Badge,
    Nav,
    NavLink,
    NavItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Card,
    CardHeader,
} from "reactstrap"; // DropdownItem, DropdownMenu, DropdownToggle
import PropTypes from "prop-types";

import { AppNavbarBrand, AppSidebarToggler } from "@coreui/react"; //AppHeaderDropdown

import logo from "../../assets/img/logo-horizontal.png";
// import sygnet from '../../assets/img/brand/LogoMobile.png';
import sygnet from "../../assets/img/brand/LogoSCM-horizontal.png";

import Sidebar from "../../components/Sidebar";
import { CartContext } from "../../components/ParadigmaCartProvider";
import ParadigmaSearch from "../../components/ParadigmaSearch";
import Login from "../../views/Pages/Login";
import { LoginContext } from "../../components/ParadigmaLoginProvider";
import "./styles.scss";

class DefaultHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginOpen: false,
            profileMenuOpen: false,
        };
    }
    static propTypes = {
        children: PropTypes.node,
        Configuracion: PropTypes.object,
    };

    render() {
        // eslint-disable-next-line
        const { loginOpen, profileMenuOpen } = this.state;
        const { children, Configuracion, Menues, ...attributes } = this.props;
        return (
            <React.Fragment>
                <div className="col-12 col-lg-3 d-inline mt-2 ml-auto mr-auto mb-2">
                    <div className="row">
                        <div className="col-4 d-lg-none">
                            <AppSidebarToggler className="d-lg-none" mobile>
                                <i
                                    className="navbar-toggler mobile-sidebar-toggler d-lg-none fa fa-align-justify"
                                    aria-hidden="true"
                                ></i>
                                <Sidebar Menues={Menues} />
                            </AppSidebarToggler>
                        </div>
                        <div className="col-4 col-lg-12">
                            <AppNavbarBrand
                                className={"mt-lg-0 d-inline logo"}
                                href={"/#/"}
                                full={{
                                    src: sygnet,
                                    alt: Configuracion.Sitio.Nombre,
                                    height: "30px",
                                }}
                                minimized={{
                                    src: sygnet,
                                    alt: Configuracion.Sitio.Nombre,
                                    height: "40px",
                                }}
                            />
                        </div>
                        <div className="col-4 d-lg-none" />
                    </div>
                </div>

                <ParadigmaSearch hyperlink />

                <Nav
                    className="col-12 col-lg-3 mx-auto ml-md-auto justify-content-center"
                    navbar
                >
                    <LoginContext.Consumer>
                        {({ logged, logout }) => {
                            if (logged) {
                                return (
                                    <React.Fragment>
                                        <Dropdown
                                            tag={"li"}
                                            className="nav-item"
                                            isOpen={profileMenuOpen}
                                            toggle={() =>
                                                this.setState({
                                                    profileMenuOpen:
                                                        !profileMenuOpen,
                                                })
                                            }
                                        >
                                            <DropdownToggle
                                                caret
                                                className="nav-link"
                                                tag="a"
                                            >
                                                <i
                                                    style={{ fontSize: "30px" }}
                                                    className="fa cui-user"
                                                ></i>
                                                {/* <Badge pill color="danger"></Badge> */}
                                            </DropdownToggle>
                                            <DropdownMenu
                                                right
                                                className="dropdown-menu-center"
                                                style={{ zIndex: 1001 }}
                                            >
                                                <DropdownItem header>
                                                    {String(
                                                        localStorage.getItem(
                                                            "displayname"
                                                        )
                                                    ).toLowerCase()}
                                                </DropdownItem>
                                                <DropdownItem href="#/perfil">
                                                    <i className="fa fa-user"></i>
                                                    Perfil
                                                </DropdownItem>
                                                <DropdownItem href="#/pedidos">
                                                    <i
                                                        className="fa fa-credit-card"
                                                        aria-hidden="true"
                                                    ></i>
                                                    Mis Pedidos
                                                </DropdownItem>
                                                <DropdownItem
                                                    onClick={() =>
                                                        this.setState(
                                                            {
                                                                loginOpen: false,
                                                            },
                                                            () => logout()
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-sign-out"></i>
                                                    Salir
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                        <CartContext.Consumer>
                                            {({ selectedItems, quantity }) => {
                                                return (
                                                    <React.Fragment>
                                                        <NavItem>
                                                            <NavLink
                                                                href={"#cart"}
                                                            >
                                                                <i
                                                                    style={{
                                                                        fontSize:
                                                                            "30px",
                                                                    }}
                                                                    className="fa cui-cart"
                                                                ></i>
                                                                {selectedItems &&
                                                                selectedItems.length ? (
                                                                    <Badge
                                                                        pill
                                                                        color="danger"
                                                                    >
                                                                        {quantity()}
                                                                    </Badge>
                                                                ) : null}
                                                            </NavLink>
                                                        </NavItem>
                                                    </React.Fragment>
                                                );
                                            }}
                                        </CartContext.Consumer>
                                    </React.Fragment>
                                );
                            } else
                                return (
                                    <React.Fragment>
                                        <NavItem>
                                            <NavLink
                                                href={"#"}
                                                onClick={() =>
                                                    this.setState({
                                                        loginOpen: true,
                                                    })
                                                }
                                            >
                                                Ingresar
                                                <Badge
                                                    pill
                                                    color="danger"
                                                ></Badge>
                                            </NavLink>
                                        </NavItem>
                                        <CartContext.Consumer>
                                            {({
                                                selectedItems,
                                                quantity,
                                                newArt,
                                            }) => {
                                                return (
                                                    <React.Fragment>
                                                        <NavItem>
                                                            <NavLink
                                                                href={"#cart"}
                                                            >
                                                                <i
                                                                    style={{
                                                                        fontSize:
                                                                            "30px",
                                                                    }}
                                                                    className={
                                                                        "fa cui-cart " +
                                                                        (newArt
                                                                            ? "carrito"
                                                                            : "")
                                                                    }
                                                                ></i>
                                                                {selectedItems &&
                                                                selectedItems.length ? (
                                                                    <Badge
                                                                        pill
                                                                        color="danger"
                                                                        className={
                                                                            newArt
                                                                                ? "carritoCant"
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {quantity()}
                                                                    </Badge>
                                                                ) : null}
                                                            </NavLink>
                                                        </NavItem>
                                                    </React.Fragment>
                                                );
                                            }}
                                        </CartContext.Consumer>
                                    </React.Fragment>
                                );
                        }}
                    </LoginContext.Consumer>
                </Nav>
                <Login
                    open={loginOpen}
                    onClose={() => this.setState({ loginOpen: false })}
                />
            </React.Fragment>
        );
    }
}

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js